import { render } from "./alphabetBook.vue?vue&type=template&id=df13528c"
import script from "./alphabetBook.vue?vue&type=script&lang=js"
export * from "./alphabetBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__